export default theme => ({
  titleContainer: {
    display: "flex",
    height: "100%",
  },
  title: {
    alignSelf: "center",
  },
  selectorContainer: {
    paddingTop: 0,
  },
  container: {
    marginBottom: 10,
  },
});
